package com.wintermar.inspection.core.ui.component.modal.util

object ModalAction {
    fun default(): ModalActionModel {
        return ModalActionModel(
            showAction = false,
            label = "",
            onClick = {}
        )
    }
}
